import { useObjectId } from '../v2/hooks/useObjectId';
import PipelineButton from './pipeline/components/PipelineButton';
import PipelineSelect from './pipeline/components/PipelineSelect';
import { shouldShowPopovers } from '../v2/utils/shouldShowPopovers';
import { jsx as _jsx } from "react/jsx-runtime";
const PropertyInputPipelineV2 = props => {
  const objectId = useObjectId();
  const {
    enablePopovers
  } = props;
  if (!shouldShowPopovers({
    enablePopovers,
    objectId
  })) {
    return /*#__PURE__*/_jsx(PipelineSelect, Object.assign({}, props));
  }
  return /*#__PURE__*/_jsx(PipelineButton, Object.assign({}, props));
};
PropertyInputPipelineV2.displayName = 'PropertyInputPipelineV2';
export default PropertyInputPipelineV2;